import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import { useEffect, useRef, useState } from 'react'
import { GOLF_CELEBRATION_MEDIA } from '../lib/golfCelebrationMedia'

const CELEBRATION_KEYS = {"birdie": ["memberWorkflows.golf.birdie", "memberWorkflows.golf.nicelyJudged", "memberWorkflows.golf.cleanWork", "memberWorkflows.golf.oneBetter", "memberWorkflows.golf.thatLlPlay"], "eagle": ["memberWorkflows.golf.eagle", "memberWorkflows.golf.thatLlDo", "memberWorkflows.golf.twoBetterVeryTidy", "memberWorkflows.golf.nowWeReTalking", "memberWorkflows.golf.exceptional"], "albatross": ["memberWorkflows.golf.albatross", "memberWorkflows.golf.wellThatEscalated", "memberWorkflows.golf.threeUnderAbsurd", "memberWorkflows.golf.youDonTSeeThatEveryDay", "memberWorkflows.golf.ridiculousInTheBestWay"], "hole_in_one": ["memberWorkflows.golf.holeINONE", "memberWorkflows.golf.oneSwingThatSAllItTook", "memberWorkflows.golf.someoneSBuyingTheDrinks", "memberWorkflows.golf.straightInTheHistoryBook", "memberWorkflows.golf.perfectlyUnnecessarySecondShot"]}
const PLAYBACK_TIMEOUT_MS = 8000

export default function GolfMilestoneCelebration({ celebration, canDismiss, onContinue }) {
  const { t } = useOptionalPrivanaI18n()
  const labels = CELEBRATION_KEYS[celebration.kind]
  const title = t(labels[0])
  const fallbackIndex = {birdie:0,eagle:1,albatross:2,hole_in_one:2}[celebration.kind]
  const copy = Number.isInteger(celebration.copyIndex) ? t(labels[celebration.copyIndex + 1]) : celebration.copy || t(labels[fallbackIndex + 1])
  const presentation = GOLF_CELEBRATION_MEDIA[celebration.kind]
  const videoRef = useRef(null)
  const timeoutRef = useRef(null)
  const [videoReady, setVideoReady] = useState(false)
  const [fallback, setFallback] = useState(false)
  const [exiting, setExiting] = useState(false)
  const reducedMotion = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true
  const useVideo = Boolean(presentation.videoUrl) && !reducedMotion && !fallback

  useEffect(() => {
    setVideoReady(false)
    setFallback(false)
    setExiting(false)
    if (reducedMotion || !presentation.videoUrl) return undefined
    const video = videoRef.current
    timeoutRef.current = setTimeout(() => setFallback(true), PLAYBACK_TIMEOUT_MS)
    const attempt = video?.play()
    if (attempt?.catch) attempt.catch(() => setFallback(true))
    return () => { clearTimeout(timeoutRef.current); video?.pause() }
  }, [celebration, presentation.videoUrl, reducedMotion])

  const markPlaying = () => { clearTimeout(timeoutRef.current); setVideoReady(true) }
  const failPlayback = () => { clearTimeout(timeoutRef.current); setFallback(true) }
  const continueFromCelebration = () => {
    if (!canDismiss || exiting) return
    if (reducedMotion) { onContinue(); return }
    setExiting(true)
    setTimeout(onContinue, 200)
  }
  return <div className={`mp-golf-celebration is-${celebration.kind}${videoReady ? ' has-video' : ''}${fallback || reducedMotion || !presentation.videoUrl ? ' is-fallback' : ' is-loading'}${exiting ? ' is-exiting' : ''}`} role="dialog" aria-modal="true" aria-label={t("memberWorkflows.golf.titleForName", {title,name:celebration.player})}>
    {(fallback || reducedMotion || !presentation.videoUrl) && <div className="mp-golf-celebration__glow" aria-hidden="true" />}
    {useVideo && <video
      ref={videoRef}
      className="mp-golf-celebration__video"
      style={{ objectFit: presentation.objectFit, objectPosition: presentation.objectPosition, transform: `scale(${presentation.scale})` }}
      src={presentation.videoUrl}
      autoPlay
      muted
      playsInline
      preload="auto"
      controls={false}
      disablePictureInPicture
      controlsList="nodownload noplaybackrate nofullscreen"
      aria-hidden="true"
      onPlaying={markPlaying}
      onError={failPlayback}
    />}
    <div className="mp-golf-celebration__shade" aria-hidden="true" />
    <div className="mp-golf-celebration__content">
      <p>{celebration.player}</p>
      {(fallback || reducedMotion || !presentation.videoUrl) && <h2>{title}</h2>}
      {(fallback || reducedMotion || !presentation.videoUrl) && <blockquote>{copy}</blockquote>}
      {!videoReady && useVideo && <span className="mp-golf-celebration__loading" aria-hidden="true">{t("memberWorkflows.golf.preparingYourMoment")}</span>}
      <button type="button" disabled={!canDismiss || exiting} aria-label={t("memberWorkflows.golf.continueAfterTitleForName", {title,name:celebration.player})} onClick={continueFromCelebration}>{t("racquetPlay.next")}</button>
    </div>
  </div>
}
